import type {
  CreateFlashcardCollectionInput,
  CreateFlashcardCollectionResponse,
  DeleteManagedFlashcardInput,
  DeleteManagedFlashcardResponse,
  FlashcardReviewOverview,
  ManagedFlashcardsResponse,
  ReviewFlashcardInput,
  ReviewFlashcardResponse,
  UpdateFlashcardInput,
  UpdateFlashcardResponse,
  UpdateManagedFlashcardStatusInput,
  UpdateManagedFlashcardStatusResponse,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const flashcardReviewOverviewKey = ["flashcard-review-overview"] as const;

export const managedFlashcardsKey = (collectionId: string | null, page: number) =>
  ["managed-flashcards", collectionId, page] as const;

export const searchedFlashcardsKey = (search: string, page: number) =>
  ["searched-flashcards", search, page] as const;

export function loadFlashcardReviewOverview(): Promise<FlashcardReviewOverview> {
  return apiRequest("/api/v1/flashcards/review");
}

export function createFlashcardCollection(
  input: CreateFlashcardCollectionInput,
): Promise<CreateFlashcardCollectionResponse> {
  return apiRequest("/api/v1/flashcard-collections", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function loadManagedFlashcards(
  collectionId: string | null,
  page: number,
): Promise<ManagedFlashcardsResponse> {
  const params = new URLSearchParams({
    collectionId: collectionId ?? "uncollected",
    page: String(page),
  });
  return apiRequest(`/api/v1/flashcards/manage?${params.toString()}`);
}

export function searchManagedFlashcards(
  search: string,
  page: number,
): Promise<ManagedFlashcardsResponse> {
  const params = new URLSearchParams({ search, page: String(page) });
  return apiRequest(`/api/v1/flashcards/search?${params.toString()}`);
}

export function updateManagedFlashcard(
  flashcardId: string,
  input: UpdateFlashcardInput,
): Promise<UpdateFlashcardResponse> {
  return apiRequest(`/api/v1/flashcards/${flashcardId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteManagedFlashcard(
  flashcardId: string,
  input: DeleteManagedFlashcardInput,
): Promise<DeleteManagedFlashcardResponse> {
  return apiRequest(`/api/v1/flashcards/${flashcardId}`, {
    method: "DELETE",
    body: JSON.stringify(input),
  });
}

export function updateManagedFlashcardStatus(
  flashcardId: string,
  input: UpdateManagedFlashcardStatusInput,
): Promise<UpdateManagedFlashcardStatusResponse> {
  return apiRequest(`/api/v1/flashcards/${flashcardId}/status`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function saveFlashcardReview(
  flashcardId: string,
  input: ReviewFlashcardInput,
): Promise<ReviewFlashcardResponse> {
  return apiRequest(`/api/v1/flashcards/${flashcardId}/review`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}
